import { Link } from "@/i18n/navigation";
import { ComponentProps } from "react";

type LinkProps = ComponentProps<typeof Link> & {
  title: string;
};

const FooterLink = ({ title, ...props }: LinkProps) => {
  return (
    <Link
      className="text-ring md:hover:text-primary max-w-full break-words transition-all duration-200"
      href={props.href}
    >
      {title}
    </Link>
  );
};

export default FooterLink;
